import { NavLink } from 'react-router-dom';
import { Calendar, CheckSquare, List, Settings } from 'lucide-react';
import { useIsPhone, useIsTablet } from '../hooks/useMediaQuery';

const tabs = [
  { to: '/', icon: Calendar, label: 'Calendar', end: true },
  { to: '/chores', icon: CheckSquare, label: 'Chores', end: false },
  { to: '/lists', icon: List, label: 'Lists', end: false },
  { to: '/settings', icon: Settings, label: 'Settings', end: false },
];

/**
 * Bottom tab bar navigation for mobile phones and tablets
 * Renders on screens < 768px (phones and tablets)
 * Fixed to bottom with safe area inset support
 */
export function BottomTabBar() {
  const isPhone = useIsPhone();
  const isTablet = useIsTablet();

  // Only render on phone and tablet screens
  if (!isPhone && !isTablet) {
    return null;
  }

  return (
    <nav className="bottom-tab-bar">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            `bottom-tab-item ${isActive ? 'bottom-tab-item--active' : 'bottom-tab-item--inactive'} active:scale-95 transition-transform`
          }
        >
          {({ isActive }) => (
            <>
              <tab.icon className="w-6 h-6" />
              {isActive && (
                <span className="text-[10px] font-semibold">{tab.label}</span>
              )}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
